<!--DataEmpty:两个状态：加载中、空数据提示 2025/05/23 14:44:52 YuAng-->

<template>
  <div v-if="loading" class="yj-data-empty">
    <img src="@/v3/assets/img/yj-loading.gif" width="64px" />
    <p class="empty-text">
      {{ loadingTip }}
    </p>
  </div>
  <div v-else class="yj-data-empty">
    <img src="@/v3/assets/img/yj-empty.png" width="190px" />
    <p v-if="emptyTip" class="empty-text">
      {{ emptyTip }}
    </p>
    <div v-else class="empty-text">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataEmpty',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingTip: {
      type: String,
      default: '查询中...'
    },
    emptyTip: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style scoped>
.yj-data-empty {
  text-align: center;
}

.empty-text {
  margin: 20px 0 30px 0;
  color: #999;
}
</style>